


































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { ISection } from "@/@types/instructions/section";

import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import IconComponent from "@/components/app/shared/icons/icon-component.vue";

@Component({
  components: { BSwitch, BSettingDd, DashCard, IconComponent },
})
class InstructionsCard extends Vue {
  @Prop({ type: Object, default: null }) item!: ISection | null;

  show = this.item?.show || false;

  get canEdit(): boolean {
    return this.$getRight("updateSections");
  }

  get canDelete(): boolean {
    return this.$getRight("deleteSections");
  }

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  @Watch("show")
  changeSection(): void {
    if (!this.item) return;
    this.$emit("changeSection", this.item._id, { show: this.show });
  }
}
export default InstructionsCard;
